import { render, staticRenderFns } from "./ScreenViewer.vue?vue&type=template&id=74b67331&"
import script from "./ScreenViewer.vue?vue&type=script&lang=ts&"
export * from "./ScreenViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports